import React, { Component } from "react";

export default class GradientBar extends Component {
  render() {
    return (
      <div
        className={`gradientBar ${
          this.props.align === "top" ? "gradientBar--top" : ""
        }`}
      ></div>
    );
  }
}
